import { useEffect, useState } from "react"
import { Link } from "react-router-dom"


export const Hero = () => {
  const [cmsData, setCmsData] = useState("")


const getCmsPost = async () => {
 
  // const response = await fetch("/.netlify/functions/cmsComunecation", {

  // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/hreo-section?populate[poster][populate]=*&populate[productLink][populate]=*")
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/hreo-section?populate[poster][populate]=*&populate[productLink][populate]=*`)
  const data = await response.json()
  setCmsData(data.data)
  console.log("from  cms Hero", data.data)
}

useEffect(() => {
  getCmsPost()
  
}, [])



  return (
    <section className="max-w-screen-xl items-center mx-auto flex flex-col lg:flex-row dark:text-slate-100 ">
        <div className="text my-5">
            <h1 className="text-5xl font-bold mr-5">{cmsData !== "" ? cmsData.title : "Loading..."}</h1>
            <p className="text-2xl my-7 mr-5 px-1 dark:text-slate-300">{cmsData !== "" ? cmsData.content[0].children[0].text : "Loading..."}</p>
             {cmsData !== "" && cmsData.productLink.href !== "" &&
            <Link rel="preconnect" to={cmsData !== "" ? cmsData.productLink.href : ""} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-base px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
              {cmsData !== "" ? cmsData.productLink.label : ""}</Link>
            }
        </div>
        <div className="visual my-5 lg:max-w-xl">
            {/* <img className="rounded-lg max-h-full" src="https://images.unsplash.com/photo-1554415707-6e8cfc93fe23?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=60" alt="CodeBook Hero Section" /> */}
            {/* <img className="rounded-lg max-h-full" src={cmsData !== "" ? `${process.env.REACT_APP_BACKEND_URL_LOCAL}${cmsData.poster.formats.medium.url}` : ""} alt="CodeBook Hero Section" /> */}
            <img rel="preconnect" className="rounded-lg w-[800px]" src={cmsData !== "" ? `${process.env.REACT_APP_BACKEND_URL}${cmsData.poster.formats.medium.url}` : ""} alt="CodeBook Hero Section" />
        </div>
    </section>
  )
}